import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import history from 'services/HistoryService'
import localStoreManagerService from 'services/LocalStoreManagerService'

export enum CreateAdStep {
  Start = 10,
  Upload = 20
}

export interface AudioBuilderState {
  createAdStep: CreateAdStep
  uploadedUrl: string | null
}

const initialState: AudioBuilderState = {
  createAdStep: localStoreManagerService.getData('createAdAudioRetail.createAdStep') || CreateAdStep.Upload,
  uploadedUrl: localStoreManagerService.getData('createAdAudioRetail.uploadedUrl')
}

function reset(state: AudioBuilderState) {
  state.createAdStep = CreateAdStep.Upload
  state.uploadedUrl = null

  localStoreManagerService.deleteData('createAdAudioRetail.createAdStep')
  localStoreManagerService.deleteData('createAdAudioRetail.uploadedUrl')
}

const createAdAudioRetail = createSlice({
  name: 'createAdAudioRetail',
  initialState,
  reducers: {
    startCreateAdStep(state: AudioBuilderState) {
      reset(state)
      history.push('/campaigns/audio/public/upload')
    },
    resetCreateAd(state: AudioBuilderState) {
      reset(state)
    },
    setCreateAdStep(state: AudioBuilderState, { payload }: PayloadAction<CreateAdStep>) {
      state.createAdStep = payload
      localStoreManagerService.saveSessionData('createAdAudioRetail.createAdStep', payload)
    },
    setUploadedUrl(state: AudioBuilderState, { payload }: PayloadAction<string>) {
      state.uploadedUrl = payload
      localStoreManagerService.saveSessionData('createAdAudioRetail.uploadedUrl', payload)
    }
  }
})

export const { startCreateAdStep, resetCreateAd, setCreateAdStep, setUploadedUrl } = createAdAudioRetail.actions

export default createAdAudioRetail.reducer
